<div class="dialog-wrapper">
  <div class="head">
    <h1 class="typo display-1 fw400 semi-condensed label-title">Manage Filters</h1>
    <button mat-icon-button (click)="closePanel()" class="custom-mat-icon-button button-close-panel">
      <mat-icon matSuffix svgIcon="ico-close" class="custom-mat-icon ico-size ico-2xs"></mat-icon>
    </button>
  </div>
  <div class="body">
    <mat-tab-group disableRipple="true" class="custom-mat-tab-group">
      <!-- List of Filters -->
      <mat-tab class="custom-mat-tab">
        <ng-template mat-tab-label>
            List of filters
        </ng-template>
        <mat-accordion *ngIf="isFiltersReady" class="custom-mat-accordion accordion-filter">
          <mat-expansion-panel *ngFor="let filter of _grid.collectionOfFilter; let i = index" class="custom-mat-expansion-panel">
            <mat-expansion-panel-header class="custom-mat-expansion-panel-header">
              <mat-panel-title class="custom-mat-panel-title">
                <span class="dot" [ngClass]="{'active': filter.status == 'active'}"></span>
                <span class="dot" [ngClass]="{'default': filter.isDefault}"></span>
                <label class="typo fw400 semi-condensed label-title">{{ filter.label }}</label>
              </mat-panel-title>
            </mat-expansion-panel-header>
              <div class="card-section">
                <label class="label-detail">{{filter.detail}}</label>
                <nav class="nav-card">
                  <button mat-button class="custom-mat-button button-card" [ngClass]="{ 'button-delete' : !deleteSubmitted }" (click)="onDeleteCustomFilter(i, filter.id)" *ngIf="filter.isEditable" [disabled]="deleteSubmitted" style="margin: auto; margin-right: 0px;">
                    <mat-icon svgIcon="ico-delete" class="custom-mat-icon ico-size ico-2xs"></mat-icon>
                    <span>Delete</span>
                  </button>
                </nav>
              </div>
          </mat-expansion-panel>
        </mat-accordion>

        <!-- skeleton -->
        <mat-accordion *ngIf="!isFiltersReady" class="custom-mat-accordion accordion-filter">
          <mat-expansion-panel *ngFor="let fake of _skeleton.generateFake(3)" class="custom-mat-expansion-panel">
            <mat-expansion-panel-header class="custom-mat-expansion-panel-header">
              <mat-panel-title class="custom-mat-panel-title">
                <span class="dot"></span>
                <span class="dot"></span>
                <label matline>
                  <skeleton-loader [theme]="{'width': '110px', 'margin-left': '10px'}"></skeleton-loader>
                </label>
              </mat-panel-title>
            </mat-expansion-panel-header>
          </mat-expansion-panel>
        </mat-accordion>

      </mat-tab>
      <!-- Create Filter -->
      <mat-tab class="custom-mat-tab">
        <ng-template mat-tab-label>Create filter</ng-template>
        <div class="body-container">
          <form [formGroup]="form" novalidate class="form-wrapper">
            <div class="form-section size size1of1">
              <div class="form-section-body">
                <mat-card class="custom-mat-card card-form-wrapper">
                  <mat-card-content class="custom-mat-card-content card-content">
                    <div class="card-section">
                      <!-- Filter Display Name -->
                      <div class="form-row">
                        <mat-form-field class="custom-mat-form-field size size1of1">
                          <input matInput required formControlName="displayName" class="custom-mat-input" placeholder="Filter display name">
                          <mat-error><error-messages [control]="form.get('displayName')"></error-messages></mat-error>
                        </mat-form-field>
                      </div>
                      <!-- Filter Rules -->
                      <div *ngIf="form.get('rules')['controls'].length > 0" class="form-row form-row-filter-rules">
                        <div class="chip-rules">
                          <mat-chip-list *ngFor="let rule of form.get('rules')['controls']; let i = index; last as isLast" class="custom-mat-chip-list chip-list-filter-rules">
                            <mat-chip class="custom-mat-chip chip-filter-rule">
                              <p class="rule-display-name">
                                <span>{{ rule.value.attributeDisplayName }}</span>
                                <span>{{ rule.value.operatorDisplayName }}</span>
                                <span *ngFor="let filterValue of rule.value.settingValues">{{ filterValue.displayName }}</span>
                              </p>
                              <mat-icon matChipRemove class="custom-mat-icon ico-cancel-rule" (click)="onRemoveRuleChip(i)">cancel</mat-icon>
                            </mat-chip>
                            <button *ngIf="isLast && !statusNewRulePanel" mat-icon-button (click)="showNewRulePanel()" class="custom-mat-icon-button button-add-rule">
                                <mat-icon class="custom-mat-icon ico-size ico-sm" svgIcon="ico-add-rule"></mat-icon>
                            </button>
                          </mat-chip-list>
                        </div>
                      </div>
                      <!-- Rule's filter options-->
                      <div *ngIf="statusNewRulePanel" class="form-row-group">
                        <!-- Attribute -->
                        <div formGroupName="ruleForm" class="form-row">
                          <mat-form-field class="custom-mat-form-field size size1of1">
                            <mat-label class="custom-mat-label">Select attribute</mat-label>
                            <mat-select required formControlName="filterAttribute" class="custom-mat-select" (selectionChange)="onSelectAttribute($event)">
                              <!-- <mat-option>Select attribute</mat-option> -->
                              <mat-option *ngFor="let attribute of collectionOfAttribute" [value]="attribute.id" class="custom-mat-option">{{ attribute.displayName }}</mat-option>
                            </mat-select>
                            <mat-error><error-messages [control]="form.get('ruleForm').get('filterAttribute')"></error-messages></mat-error>
                          </mat-form-field>
                        </div>
                        <!-- Operator -->
                        <div *ngIf="this.filterAttribute" formGroupName="ruleForm" class="form-row">
                          <mat-form-field class="custom-mat-form-field size size1of1">
                            <mat-label class="custom-mat-label">Select operators</mat-label>
                            <mat-select required formControlName="filterOperator" class="custom-mat-select" (selectionChange)="onSelectOperator($event)">
                              <!-- <mat-option>Select attribute</mat-option> -->
                              <mat-option class="custom-mat-option" *ngFor="let operator of collectionOfOperator" [value]="operator.id">{{ operator.displayName }}</mat-option>
                            </mat-select>
                            <mat-error><error-messages [control]="form.get('ruleForm').get('filterOperator')"></error-messages></mat-error>
                          </mat-form-field>
                        </div>
                        <!-- Value -->
                        <div formGroupName="ruleForm" class="form-row">
                          <ng-container *ngIf="selectedAttributeType == 'date'">
                            <!-- Enter value using date picker -->
                            <mat-form-field *ngIf="selectedOperatorName == 'equals' || selectedOperatorName == 'before' || selectedOperatorName == 'after'" class="custom-mat-form-field field-date-picker">
                              <input matInput formControlName="filterValue" [matDatepicker]="filterValue" panelClass="custom-mat-datepicker-panel" [disabled]="true"/>
                              <mat-datepicker-toggle matSuffix [for]="filterValue" class="custom-mat-datepicker-toggle"></mat-datepicker-toggle>
                              <mat-datepicker #filterValue [disabled]="false"></mat-datepicker>
                              <mat-error><error-messages [control]="form.get('ruleForm').get('filterValue')"></error-messages></mat-error>
                            </mat-form-field>
                            <!-- Enter value using range date picker -->
                            <mat-form-field *ngIf="selectedOperatorType == 'between'" class="custom-mat-form-field field-date-picker">
                              <mat-label>Date Range</mat-label>
                              <mat-date-range-input [rangePicker]="pickerRange">
                                <input matStartDate formControlName="startDate" placeholder="Start date" [disabled]="true">
                                <input matEndDate formControlName="endDate" placeholder="End date" [disabled]="true">
                              </mat-date-range-input>
                              <mat-date-range-picker #pickerRange disabled="false"></mat-date-range-picker>
                              <mat-datepicker-toggle matSuffix [for]="pickerRange" class="custom-mat-datepicker-toggle"></mat-datepicker-toggle>
                              <mat-error><error-messages [control]="form.get('ruleForm').get('startDate')"></error-messages></mat-error>
                              <mat-error><error-messages [control]="form.get('ruleForm').get('endDate')"></error-messages></mat-error>
                            </mat-form-field>
                          </ng-container>
                          <ng-container *ngIf="selectedAttributeType == 'string' || selectedAttributeType == 'number' || selectedAttributeType == 'other'">
                            <mat-form-field *ngIf="selectedOperatorType == 'cb_text'" class="custom-mat-form-field size size1of1">
                              <mat-label class="custom-mat-label">Enter value</mat-label>
                              <input matInput formControlName="filterValue" class="custom-mat-input" placeholder="Value" color="accent">
                              <mat-error><error-messages [control]="form.get('ruleForm').get('filterValue')"></error-messages></mat-error>
                            </mat-form-field>
                              <!-- Enter value using checkbox -->
                            <mat-list *ngIf="selectedOperatorType == 'multi_select'" class="custom-mat-list list-filter-rule-options">
                              <mat-list-item *ngFor="let option of collectionOfAllowValue" class="custom-mat-list-item">
                                <mat-checkbox (change)="onMultiListValueChange($event, option)" class="custom-mat-checkbox rounded" color="primary" value="option">{{ option.displayName ? option.displayName : option.name }}</mat-checkbox>
                              </mat-list-item>
                              <mat-error><error-messages [control]="form.get('ruleForm').get('filterValueMultiList')"></error-messages></mat-error>
                            </mat-list>
                            <!-- Enter value using Radio Options -->
                            <mat-radio-group *ngIf="selectedOperatorType == 'list'" (change)="onListValueChange($event)" class="custom-mat-radio-group radio-group-filter-values">
                              <label class="typo placeholder semi-condensed">Select Value</label>
                              <mat-radio-button *ngFor="let option of collectionOfAllowValue" class="custom-mat-radio-button" color="primary" [value]="option">{{ option.displayName ? option.displayName : option.name }}</mat-radio-button>
                            </mat-radio-group>
                            <mat-error><error-messages [control]="form.get('ruleForm').get('filterValueSingleList')"></error-messages></mat-error>
                          </ng-container>
                        </div>
                        <!-- Nav -->
                        <div class="form-row form-row-nav">
                          <button *ngIf="form.get('rules')['controls'].length > 0" mat-button (click)="onCancelNewRule()" color="warn" disableRipple="true" class="custom-mat-button button-cancel-new-rule">
                            <mat-icon svgIcon="ico-delete-rule" class="custom-mat-icon ico-size ico-sm"></mat-icon>
                            <span>Cancel</span>
                          </button>
                          <button mat-button disableRipple="true" (click)="onAddRuleToFilter()" class="custom-mat-button button-new-rule">
                            <mat-icon svgIcon="ico-add-rule" class="custom-mat-icon ico-size ico-sm"></mat-icon>
                            <span>Add rule</span>
                          </button>
                        </div>
                      </div>
                    </div>
                  </mat-card-content>
                </mat-card>
              </div>
            </div>
          </form>
        </div>
        <nav class="post-form">
          <button mat-flat-button (click)="onSubmit()" color="primary" [disabled]="form.get('rules')['controls'].length == 0 || formSubmitted" ngClass="{'is--loading': formSubmitted}" class="custom-mat-button-primary rounded typo uppercase">Save new filter</button>
        </nav>
      </mat-tab>
    </mat-tab-group>
  </div>
</div>
